<div style="margin-top:50px;"></div>
<div class="p-4">

  <div class="sm:p-4 sm:bg-white relative sm:shadow-md sm:rounded-md">
    <span class="block mb-3 text-black text-sm col-span-full font-semibold font-mont">Weighted Report</span>
    <div *ngIf="loading" class="absolute bg-white/50 z-50 flex inset-0 items-center justify-center p-10">
      <mat-spinner [diameter]="30" mode="indeterminate"></mat-spinner>
    </div>

    <div class="flex flex-col md:grid mb-4 grid-cols-2 gap-y-2 gap-x-4">
      <div class="w-full">
        <app-custom-field [taller]="true" label="Session" name="session_id" [nolabel]="true" containerClass="bg-white"
          class="w-full">
          <mat-select name="session_id" [(ngModel)]="session_id" (ngModelChange)="onWeightedChange($event)">
            <mat-option *ngFor="let session of sessionLabels" [value]="session.session_id">
              {{ session.label }}
            </mat-option>
          </mat-select>
        </app-custom-field>
      </div>

      <div class="flex items-center gap-2 md:justify-end">
        <button *ngIf="company.allow_portal_result_print && student?.eligible" (click)="print()" mat-button
          mat-raised-button color="primary">PRINT REPORT</button>
        <button *ngIf="company.allow_portal_result_print" (click)="print(true)" mat-button mat-raised-button
          color="primary">PRINT ALL REPORT</button>
      </div>
    </div>

    <div class="flex flex-col text-center items-center justify-center gap-2 py-20 max-w-sm m-auto"
      *ngIf="!student?.eligible">
      <h3 class="text-black/30 mb-2">
        <span class="text-3xl">{{student?.percentageString}}</span>
        <small class="text-[1rem] ml-1">Paid</small>
      </h3>
      <p class="text-red-600 mb-2 max-w-sm mx-auto text-center">{{ student?.eligibilityMessage}}</p>
      <button mat-dialog-close color="primary" mat-raised-button routerLink="/home/pay-tuition">Make
        Payment</button>
    </div>

    <div *ngIf="student?.eligible" class="rp-container">
      <ng-container *ngIf="show_total">
        <table class="table-auto w-full border-collapse border border-gray-500">
          <thead>
            <tr>
              <th class="tt w-[4%]">#</th>
              <th class="tt w-1/4">Subject</th>
              <th colspan="2" class="tt w-1/12 bg-indigo-50" *ngIf="
                      ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                      (missing_term && student?.cd?.t1)
                    ">
                1st Term
              </th>
              <th colspan="2" class="tt w-1/12 bg-yellow-50" *ngIf="
                      ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                      (missing_term && student?.cd?.t2)
                    ">
                2nd Term
              </th>
              <th colspan="2" class="tt w-1/12 bg-purple-50" *ngIf="
                      ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                      (missing_term && student?.cd?.t3)
                    ">
                3rd Term
              </th>
              <th class="tt w-1/12">Term Total</th>
              <th class="tt w-1/12" *ngIf="student?.cd?.cc_grade == 'Y'">Grade</th>
              <th class="tt w-1/12">Total</th>
              <th class="tt w-1/12">T. Avg</th>
              <ng-container *ngIf="student.new_version">
                <th class="tt w-1/12">T. Pos.</th>
                <th colspan="2" class="tt w-1/12 bg-green-50 text-xs">
                  Highest Sc.
                </th>
                <th colspan="2" class="tt w-1/12 bg-red-50 text-xs">
                  Lowest Sc.
                </th>
              </ng-container>
              <th class="tt w-[10%]" *ngIf="student?.cd?.cc_grade == 'Y'">Remark</th>
            </tr>
            <tr class="sub">
              <th></th>
              <th>
                <div class="flex space-x-1 text-xs">
                  <div class="flex-1" *ngIf="
                          ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                          (missing_term && student?.cd?.t1)
                        ">
                    [T.1 = {{ student?.cd?.tts1 ?? 0 }}]
                  </div>
                  <div class="flex-1" *ngIf="
                          ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                          (missing_term && student?.cd?.t2)
                        ">
                    [T.2 = {{ student?.cd?.tts2  ?? 0 }}]
                  </div>
                  <div class="flex-1" *ngIf="
                          ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                          (missing_term && student?.cd?.t3)
                        ">
                    [T.3 = {{ student?.cd?.tts3  ?? 0 }}]
                  </div>
                </div>
              </th>
              <ng-container *ngIf="
                      ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                      (missing_term && student?.cd?.t1)
                    ">
                <th class="bg-indigo-50 wtd">Wtd</th>
                <th class="bg-indigo-50">Total</th>
              </ng-container>
              <ng-container *ngIf="
                      ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                      (missing_term && student?.cd?.t2)
                    ">
                <th class="bg-indigo-50 wtd">Wtd</th>
                <th class="bg-indigo-50">Total</th>
              </ng-container>
              <ng-container *ngIf="
                      ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                      (missing_term && student?.cd?.t3)
                    ">
                <th class="bg-indigo-50 wtd">Wtd</th>
                <th class="bg-indigo-50">Total</th>
              </ng-container>

              <th *ngIf="student?.cd?.cc_grade == 'Y'"></th>
              <ng-container *ngIf="student?.new_version">
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </ng-container>
              <th class="bg-green-50 wtd">Wtd</th>
              <th class="bg-green-50">Total</th>
              <th class="bg-red-50 wtd">Wtd</th>
              <th class="bg-red-50">Total</th>
              <th *ngIf="student?.cd?.cc_grade == 'Y'"></th>
            </tr>
          </thead>
          <tbody *ngIf="
                  student && student.subjects && student?.subjects.length > 0
                ">
            <ng-container *ngFor="let sub of student.subjects; let i = index">
              <tr *ngIf="include_zero || (!include_zero && !sub.is_zero)">
                <td>
                  {{ i + 1 }}
                </td>
                <td class="uppercase">
                  <div class="w-[14em] truncate">
                    {{ sub.title }}
                  </div>
                </td>
                <ng-container *ngIf="
                        ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                        (missing_term && student?.cd?.t1)
                      ">
                  <td class="bg-indigo-50 wtd">
                    {{ sub.t1available ? sub.terms[0]?.weighted : "-" }}
                  </td>
                  <td class="bg-indigo-50">
                    {{ sub.t1available ? sub.terms[0].total : "-" }}
                  </td>
                </ng-container>
                <ng-container *ngIf="
                        ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                        (missing_term && student?.cd?.t2)
                      ">
                  <td class="bg-indigo-50 wtd">
                    {{ sub.t2available ? sub.terms[0]?.weighted : "-" }}
                  </td>
                  <td class="bg-indigo-50">
                    {{ sub.t2available ? sub.terms[0].total : "-" }}
                  </td>
                </ng-container>
                <ng-container *ngIf="
                        ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                        (missing_term && student?.cd?.t3)
                      ">
                  <td class="bg-indigo-50 wtd">
                    {{ sub.t3available ? sub.terms[0]?.weighted : "-" }}
                  </td>
                  <td class="bg-indigo-50">
                    {{ sub.t3available ? sub.terms[0].total : "-" }}
                  </td>
                </ng-container>

                <td class="wtd">
                  {{ sub.weighted }}
                </td>
                <td *ngIf="student?.cd?.cc_grade == 'Y'" class="font-bold uppercase">
                  {{ sub?.grade }}
                </td>
                <td>
                  {{ sub.total }}
                </td>
                <td class="wtd">
                  {{ sub.weighted_average }}
                </td>
                <ng-container *ngIf="student?.new_version">
                  <td>
                    {{ sub?.sub_position ?? "P" }}
                  </td>
                  <td class="bg-green-50 wtd">{{ sub.highest_weighted }}</td>
                  <td class="bg-green-50">{{ sub.highest_total }}</td>
                  <td class="bg-red-50 wtd">{{ sub.lowest_weighted }}</td>
                  <td class="bg-red-50">{{ sub.lowest_total }}</td>
                </ng-container>
                <td *ngIf="student?.cd?.cc_grade == 'Y'">
                  <div class="w-[8em] truncate uppercase">
                    {{ sub.comment }}
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>

      <ng-container *ngIf="!show_total">
        <table class="table-auto w-full border-collapse border border-gray-500">
          <thead>
            <tr>
              <th class="tt w-[4%]">#</th>
              <th class="tt w-1/4">Subject</th>
              <th class="tt w-1/12 bg-indigo-50" *ngIf="
                      ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                      (missing_term && student?.cd?.t1)
                    ">
                <div class="text-sm">1st Term</div>
                <div class="text-xs" *ngIf="student?.new_version">[ {{ student?.cd?.tts1 ?? 0 }} ]</div>
              </th>
              <th class="tt w-1/12 bg-yellow-50" *ngIf="
                      ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                      (missing_term && student?.cd?.t2)
                    ">
                <div class="text-sm">2nd Term</div>
                <div class="text-xs" *ngIf="student?.new_version">[ {{ student?.cd?.tts2  ?? 0 }} ]</div>
              </th>
              <th class="tt w-1/12 bg-purple-50" *ngIf="
                      ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                      (missing_term && student?.cd?.t3)
                    ">
                <div class="text-sm">3rd Term</div>
                <div class="text-xs" *ngIf="student?.new_version">[ {{ student?.cd?.tts3  ?? 0 }} ]</div>
              </th>
              <th class="tt w-1/12">Total</th>
              <th class="tt w-1/12" *ngIf="student?.cd?.cc_grade == 'Y'">Grade</th>
              <th class="tt w-1/12">T. Avg</th>
              <ng-container *ngIf="student?.new_version && hilo">
                <th class="tt w-1/12">T. Pos.</th>
                <th class="tt w-1/12 bg-green-50 text-xs">High T.</th>
                <th class="tt w-1/12 bg-red-50 text-xs">Low T.</th>
              </ng-container>
              <th class="tt w-[10%]" *ngIf="student?.cd?.cc_grade == 'Y'">Remark</th>
            </tr>
          </thead>
          <tbody *ngIf="
                  student && student.subjects && student?.subjects.length > 0
                ">
            <ng-container *ngFor="let sub of student.subjects; let i = index">
              <tr>
                <td>
                  {{ i + 1 }}
                </td>
                <td class="uppercase">
                  <div class="w-[14em] truncate">
                    {{ sub.title }}
                  </div>
                </td>
                <td class="bg-indigo-50 wtd">
                  {{ sub.tw1 ?? "-" }}
                </td>
                <td class="bg-yellow-50 wtd">
                  {{ sub.tw2 ?? "-" }}
                </td>
                <td>
                  {{ sub.tw3 ?? "-" }}
                </td>
                <td class="wtd">
                  {{ sub.total}}
                </td>
                <td *ngIf="student?.cd?.cc_grade == 'Y'" class="font-bold uppercase">
                  {{ sub.grade }}
                </td>
                <td class="wtd">
                  {{ sub.weighted_avg }}
                </td>
                <ng-container *ngIf="student?.new_version && hilo">
                  <td>
                    {{ fetch_for_all ? sub.w_f_sub_position : sub.w_sub_position  }}
                  </td>
                  <td class="bg-green-50">
                    {{ fetch_for_all ? sub.f_w_highest_score : sub.w_highest_score }}
                  </td>
                  <td class="bg-red-50">
                    {{ fetch_for_all ? sub.f_w_lowest_score : sub.w_lowest_score }}
                  </td>

                </ng-container>
                <td *ngIf="student?.cd?.cc_grade == 'Y'">
                  <div class="w-[8em] truncate uppercase">
                    {{ sub.comment }}
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>








      <div *ngIf="student?.subjects.length == 0" class="uppercase font-bold text-xl p-2">
        No results is found for session
      </div>

    </div>

  </div>






  <div id="print-report" ngxPrint class="print:flex hidden">
    <div class="mx-4 my-1 font-nexa" *ngIf="company.allow_portal_result_print  && student?.eligible">
      <section class="flex items-center space-x-2">
        <div class="w-[10%]">
          <img class="w-full h-auto" [src]="company?.logo" alt="Logo"
            onerror="this.src='assets/images/edozzier-logo.png'" />
        </div>
        <div class="w-[90%] flex flex-col items-center text-center">
          <div class="text-4xl font-bold uppercase">
            {{ company?.name }}
          </div>
          <div class="text-base">
            <span *ngIf="company?.address">
              {{ company?.address ?? "" }}
            </span>
          </div>
        </div>
      </section>

      <div class="relative flex items-center justify-center -mt-2 mb-0.5">
        <div class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-gray-300"></div>
        </div>
        <div class="relative bg-white px-4 text-center text-gray-500">
          <div class="flex space-x-1 uppercase px-4 py-2 shadow-md border text-2xl font-bold tracking-tight">
            <span>{{ student?.session_year }} - Weighted Report</span>
          </div>
        </div>
      </div>
      <section class="flex items-center space-x-2">
        <div class="w-[40%] flex items-center space-x-4">
          <div class="w-24 h-24 overflow-hidden">
            <img src="{{ student?.passport }}"
              class="w-[80px] h-[80px] object-cover border border-gray-300 shadow-sm rounded-lg"
              onerror="this.src='assets/images/man.png'" alt="Student Image" />
          </div>
          <div class="flex flex-col justify-between uppercase w-full truncate">
            <div class="font-semibold text-2xl w-full truncate">
              {{ student?.student_name }}
            </div>
            <div class="text-xl font-semibold w-full truncate">
              {{ student?.matric_no }}
            </div>
            <div class="flex space-x-2 text-sm w-full text-gray-600 uppercase">
              <span>{{ student?.gender }}</span>
              <span *ngIf="student?.gender && student?.date_of_birth && dob">/</span>
              <span *ngIf="dob && student?.date_of_birth">DOB: {{ student?.date_of_birth | date : "dd/MM/yyyy" }}</span>
            </div>
          </div>
        </div>

        <div class="w-[40%]">
          <div class="text-2xl font-bold uppercase truncate flex">
            <div class="cc">{{ student?.category }}</div>
            <div class="mx-0.5">-</div>
            <div class="cc">{{ student?.name }}</div>
            <div class="mx-0.5">-</div>
            <div class="cc">{{ student?.tag }}</div>
          </div>
          <div class="flex space-x-2 text-base items-center uppercase truncate">
            <span class="font-semibold text-xs">Class Teacher:</span>
            <span class="text-xl font-bold truncate">{{ student?.staff_name }}</span>
          </div>
        </div>

        <ng-container *ngIf="class_position && student?.new_version">
          <div class="w-[20%] flex flex-col">
            <ng-container>
              <div class="flex items-center space-x-2 text-gray-900">
                <div class="text-base font-semibold w-[7rem]">Student Pos:</div>
                <div class="text-3xl font-bold">
                  <ng-container *ngIf="fetch_for_all">
                    {{ student?.cd?.w_f_position | number : "2.0" }}
                  </ng-container>
                  <ng-container *ngIf="!fetch_for_all">
                    {{ student?.cd?.w_position | number : "2.0" }}
                  </ng-container>

                </div>
              </div>

              <div class="flex items-center space-x-2 bg-orange-50 text-sm">
                <div class="font-semibold w-[7rem]">No. Students:</div>
                <div class="font-bold text-xl">
                  <ng-container *ngIf="fetch_for_all">
                    {{ student?.cd?.f_count  }}
                  </ng-container>
                  <ng-container *ngIf="!fetch_for_all">
                    {{ student?.cd?.count }}
                  </ng-container>
                </div>
              </div>
            </ng-container>

          </div>
        </ng-container>
      </section>
      <div class="relative flex items-center justify-center my-0.5 mb-2">
        <div class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-gray-300"></div>
        </div>
      </div>

      <div class="flex p-2 font-bold uppercase items-center text-sm">

        <div class="w-[50%] text-left">
          Next Term Begins:
          {{
      student?.cd?.curr_term?.next_term_begins
        ? (student?.cd.curr_term.next_term_begins | date : "mediumDate")
        : "-"
    }}
        </div>
      </div>


      <section>
        <ng-container *ngIf="show_total">
          <table class="table-auto w-full border-collapse border border-gray-500">
            <thead>
              <tr>
                <th class="tt w-[4%]">#</th>
                <th class="tt w-1/4">Subject</th>
                <th colspan="2" class="tt w-1/12 bg-indigo-50" *ngIf="
                ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                (missing_term && student?.cd?.t1)
              ">
                  1st Term
                </th>
                <th colspan="2" class="tt w-1/12 bg-yellow-50" *ngIf="
                ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                (missing_term && student?.cd?.t2)
              ">
                  2nd Term
                </th>
                <th colspan="2" class="tt w-1/12 bg-purple-50" *ngIf="
                ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                (missing_term && student?.cd?.t3)
              ">
                  3rd Term
                </th>
                <th class="tt w-1/12">Term Total</th>
                <th class="tt w-1/12" *ngIf="student?.cd?.cc_grade == 'Y'">Grade</th>
                <th class="tt w-1/12">Total</th>
                <th class="tt w-1/12">T. Avg</th>
                <th class="tt w-1/12" *ngIf="subject_position">T. Pos.</th>
                <ng-container *ngIf="hilo">
                  <th colspan="2" class="tt w-1/12 bg-green-50 text-xs">
                    Highest Sc.
                  </th>
                  <th colspan="2" class="tt w-1/12 bg-red-50 text-xs">
                    Lowest Sc.
                  </th>
                </ng-container>
                <th class="tt w-[10%]" *ngIf="student?.cd?.cc_grade == 'Y'">Remark</th>
              </tr>
              <tr class="sub">
                <th></th>
                <th>
                  <div class="flex space-x-1 text-xs">
                    <div class="flex-1" *ngIf="
                    ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                    (missing_term && student?.cd?.t1)
                  ">
                      [T.1 = {{ student?.cd?.tts1 ?? 0 }}]
                    </div>
                    <div class="flex-1" *ngIf="
                    ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                    (missing_term && student?.cd?.t2)
                  ">
                      [T.2 = {{ student?.cd?.tts2  ?? 0 }}]
                    </div>
                    <div class="flex-1" *ngIf="
                    ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                    (missing_term && student?.cd?.t3)
                  ">
                      [T.3 = {{ student?.cd?.tts3  ?? 0 }}]
                    </div>
                  </div>
                </th>
                <ng-container *ngIf="
                ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                (missing_term && student?.cd?.t1)
              ">
                  <th class="bg-indigo-50 wtd">Wtd</th>
                  <th class="bg-indigo-50">Total</th>
                </ng-container>
                <ng-container *ngIf="
                ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                (missing_term && student?.cd?.t2)
              ">
                  <th class="bg-indigo-50 wtd">Wtd</th>
                  <th class="bg-indigo-50">Total</th>
                </ng-container>
                <ng-container *ngIf="
                ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                (missing_term && student?.cd?.t3)
              ">
                  <th class="bg-indigo-50 wtd">Wtd</th>
                  <th class="bg-indigo-50">Total</th>
                </ng-container>

                <th *ngIf="student?.cd?.cc_grade == 'Y'"></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <ng-container *ngIf="hilo">
                  <th class="bg-green-50 wtd">Wtd</th>
                  <th class="bg-green-50">Total</th>
                  <th class="bg-red-50 wtd">Wtd</th>
                  <th class="bg-red-50">Total</th>
                </ng-container>
                <th *ngIf="student?.cd?.cc_grade == 'Y'"></th>
              </tr>
            </thead>
            <tbody *ngIf="
            student && student.subjects && student?.subjects.length > 0
          ">
              <ng-container *ngFor="let sub of student.subjects; let i = index">
                <tr *ngIf="include_zero || (!include_zero && !sub.is_zero)">
                  <td>
                    {{ i + 1 }}
                  </td>
                  <td class="uppercase">
                    <div class="w-[14em] truncate">
                      {{ sub.title }}
                    </div>
                  </td>
                  <ng-container *ngIf="
                  ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                  (missing_term && student?.cd?.t1)
                ">
                    <td class="bg-indigo-50 wtd">
                      {{ sub.t1available ? sub.terms[0]?.weighted : "-" }}
                    </td>
                    <td class="bg-indigo-50">
                      {{ sub.t1available ? sub.terms[0].total : "-" }}
                    </td>
                  </ng-container>
                  <ng-container *ngIf="
                  ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                  (missing_term && student?.cd?.t2)
                ">
                    <td class="bg-indigo-50 wtd">
                      {{ sub.t2available ? sub.terms[0]?.weighted : "-" }}
                    </td>
                    <td class="bg-indigo-50">
                      {{ sub.t2available ? sub.terms[0].total : "-" }}
                    </td>
                  </ng-container>
                  <ng-container *ngIf="
                  ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                  (missing_term && student?.cd?.t3)
                ">
                    <td class="bg-indigo-50 wtd">
                      {{ sub.t3available ? sub.terms[0]?.weighted : "-" }}
                    </td>
                    <td class="bg-indigo-50">
                      {{ sub.t3available ? sub.terms[0].total : "-" }}
                    </td>
                  </ng-container>

                  <td class="wtd">
                    {{ sub.weighted }}
                  </td>
                  <td *ngIf="student?.cd?.cc_grade == 'Y'" class="font-bold uppercase">
                    {{ sub?.grade }}
                  </td>
                  <td>
                    {{ sub.total }}
                  </td>
                  <td class="wtd">
                    {{ sub.weighted_average }}
                  </td>
                  <td *ngIf="subject_position">
                    {{ sub?.sub_position ?? "P" }}
                  </td>
                  <ng-container *ngIf="hilo">
                    <td class="bg-green-50 wtd">{{ sub.highest_weighted }}</td>
                    <td class="bg-green-50">{{ sub.highest_total }}</td>
                    <td class="bg-red-50 wtd">{{ sub.lowest_weighted }}</td>
                    <td class="bg-red-50">{{ sub.lowest_total }}</td>
                  </ng-container>
                  <td *ngIf="student?.cd?.cc_grade == 'Y'">
                    <div class="w-[8em] truncate uppercase">
                      {{ sub.comment }}
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ng-container>

        <ng-container *ngIf="!show_total">
          <table class="table-auto w-full border-collapse border border-gray-500">
            <thead>
              <tr>
                <th class="tt w-[4%]">#</th>
                <th class="tt w-1/4">Subject</th>
                <th class="tt w-1/12 bg-indigo-50" *ngIf="
                ((student?.cd?.t1 || !student?.cd?.t1) && !missing_term) ||
                (missing_term && student?.cd?.t1)
              ">
                  <div class="text-sm">1st Term</div>
                  <div class="text-xs" *ngIf="student?.new_version">[ {{ student?.cd?.tts1 ?? 0 }} ]</div>
                </th>
                <th class="tt w-1/12 bg-yellow-50" *ngIf="
                ((student?.cd?.t2 || !student?.cd?.t2) && !missing_term) ||
                (missing_term && student?.cd?.t2)
              ">
                  <div class="text-sm">2nd Term</div>
                  <div class="text-xs" *ngIf="student?.new_version">[ {{ student?.cd?.tts2  ?? 0 }} ]</div>
                </th>
                <th class="tt w-1/12 bg-purple-50" *ngIf="
                ((student?.cd?.t3 || !student?.cd?.t3) && !missing_term) ||
                (missing_term && student?.cd?.t3)
              ">
                  <div class="text-sm">3rd Term</div>
                  <div class="text-xs" *ngIf="student?.new_version">[ {{ student?.cd?.tts3  ?? 0 }} ]</div>
                </th>
                <th class="tt w-1/12">Total</th>
                <th class="tt w-1/12" *ngIf="student?.cd?.cc_grade == 'Y'">Grade</th>
                <th class="tt w-1/12">T. Avg</th>
                <ng-container *ngIf="student?.new_version ">
                  <th class="tt w-1/12" *ngIf="subject_position">T. Pos.</th>
                  <ng-container *ngIf="hilo">
                    <th class="tt w-1/12 bg-green-50 text-xs">High T.</th>
                    <th class="tt w-1/12 bg-red-50 text-xs">Low T.</th>
                  </ng-container>
                </ng-container>
                <th class="tt w-[10%]" *ngIf="student?.cd?.cc_grade == 'Y'">Remark</th>
              </tr>
            </thead>
            <tbody *ngIf="
            student && student.subjects && student?.subjects.length > 0
          ">
              <ng-container *ngFor="let sub of student.subjects; let i = index">
                <tr>
                  <td>
                    {{ i + 1 }}
                  </td>
                  <td class="uppercase">
                    <div class="w-[14em] truncate">
                      {{ sub.title }}
                    </div>
                  </td>
                  <td class="bg-indigo-50 wtd">
                    {{ sub.tw1 ?? "-" }}
                  </td>
                  <td class="bg-yellow-50 wtd">
                    {{ sub.tw2 ?? "-" }}
                  </td>
                  <td class="bg-purple-50 wtd">
                    {{ sub.tw3 ?? "-" }}
                  </td>
                  <td class="wtd">
                    {{ sub.total}}
                  </td>
                  <td *ngIf="student?.cd?.cc_grade == 'Y'" class="font-bold uppercase">
                    {{ sub.grade }}
                  </td>
                  <td class="wtd">
                    {{ sub.weighted_avg }}
                  </td>
                  <ng-container *ngIf="student?.new_version">
                    <td *ngIf="subject_position">
                      {{ fetch_for_all ? sub.w_f_sub_position : sub.w_sub_position  }}
                    </td>
                    <ng-container *ngIf="hilo">
                      <td class="bg-green-50">
                        {{ fetch_for_all ? sub.f_w_highest_score : sub.w_highest_score }}
                      </td>
                      <td class="bg-red-50">
                        {{ fetch_for_all ? sub.f_w_lowest_score : sub.w_lowest_score }}
                      </td>
                    </ng-container>

                  </ng-container>
                  <td *ngIf="student?.cd?.cc_grade == 'Y'">
                    <div class="w-[8em] truncate uppercase">
                      {{ sub.comment }}
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ng-container>

        <div *ngIf="student?.subjects.length == 0" class="uppercase font-bold text-xl p-2">
          No results is found for session
        </div>
      </section>


      <section class="flex mt-4 space-x-4 skb">
        <div class="w-[45%]">
          <div class="w-full">
            <fieldset class="shadow-sm rounded-md p-2 relative">
              <legend
                class="text-base font-semibold text-gray-700 px-2 absolute border shadow-sm -top-3 bg-white w-[8em]">
                Skills
              </legend>
              <div class="mt-3 text-gray-700 w-full">
                <table class="w-full">
                  <tbody>
                    <tr>
                      <td>Hand Writing</td>
                      <td>{{ student?.skb?.handwriting ?? "-" }}</td>
                    </tr>
                    <tr>
                      <td>Fluency</td>
                      <td>
                        {{ student?.skb?.fluency ?? "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Sport</td>
                      <td>
                        {{ student?.skb?.sport ?? "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Handling of tools in lab &amp; workshop</td>
                      <td>
                        {{ student?.skb?.h_of_tools ?? "-" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="w-[55%]">
          <div class="w-full">
            <fieldset class="shadow-sm rounded-md p-2 relative">
              <legend
                class="text-base font-semibold text-gray-700 px-2 absolute border shadow-sm -top-3 bg-white w-[8em]">
                Behaviour
              </legend>
              <div class="mt-3 text-gray-700 w-full">
                <table class="w-full">
                  <tbody>
                    <tr>
                      <td>Punctuality</td>
                      <td>{{ student?.skb?.punctuality ?? "-" }}</td>
                    </tr>
                    <tr>
                      <td>Neatness</td>
                      <td>
                        {{ student?.skb?.neatness ?? "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Politeness</td>
                      <td>
                        {{ student?.skb?.politeness ?? "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Relationship with other student</td>
                      <td>
                        {{ student?.skb?.rel_with_student ?? "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Organization Ability</td>
                      <td>
                        {{ student?.skb?.organisation_ab ?? "-" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
          </div>
        </div>
      </section>

      <section>
        <div class="w-full">
          <fieldset class="shadow-sm rounded-md p-2 relative">
            <legend
              class="text-base font-semibold text-gray-700 px-2 absolute border shadow-sm -top-3 bg-white w-[8em]">
              Comments
            </legend>
            <div class="flex flex-col gap-2 mt-3">
              <!-- Teacher Comment -->
              <div class="flex items-center">
                <label class="w-[100px] font-semibold text-gray-600 pt-2 text-sm">Class Teacher:</label>
                <div class="flex-1 border p-2 font-bold rounded-md bg-gray-100 uppercase">
                  {{ student?.ct_comment ?? "-" }}
                </div>
              </div>
              <!-- Principal Comment -->
              <div class="flex items-center">
                <label
                  class="w-[100px] font-semibold text-gray-600 pt-2 text-sm truncate">{{ student?.leader }}:</label>
                <div class="flex-1 border p-2 font-bold rounded-md bg-gray-100 uppercase">
                  {{ student?.p_comment ?? "-" }}
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </section>

      <section class="grid grid-cols-2 gap-6 mt-5" *ngIf="student?.ct_signature && student?.p_signature">
        <div class="flex flex-col items-center text-center">
          <img [src]="student?.ct_signature" class="w-32 h-16 object-cover rounded-lg" alt="Class Teacher Signature" />
          <div class="mt-1 text-lg font-semibold text-gray-700">
            Class Teacher
          </div>
        </div>
        <div class="flex flex-col items-center text-center">
          <img [src]="student?.p_signature" class="w-32 h-16 object-cover rounded-lg" alt="Leader Signature" />
          <div class="mt-1 text-lg font-semibold text-gray-700">
            {{ student?.leader }}
          </div>
        </div>
      </section>
    </div>
    <footer class="fixed inset-x-0 bottom-0 w-full px-4">
      <div class="bg-gray-800 text-white flex justify-between items-center px-4 py-1">
        <div class="text-lg font-bold">Edozzier</div>
        <div class="text-sm">Edu-verse For Forward Thinking Institutions</div>
      </div>
    </footer>
  </div>






  <div id="print-all-report" ngxPrint class="print:flex hidden">
    <div *ngFor="let stud of arr" class="print-page">

      <div class="mx-4 my-1 font-nexa" *ngIf="company.allow_portal_result_print">
        <section class="flex items-center space-x-2">
          <div class="w-[10%]">
            <img class="w-full h-auto" [src]="company?.logo" alt="Logo"
              onerror="this.src='assets/images/edozzier-logo.png'" />
          </div>
          <div class="w-[90%] flex flex-col items-center text-center">
            <div class="text-4xl font-bold uppercase">
              {{ company?.name }}
            </div>
            <div class="text-base">
              <span *ngIf="company?.address">
                {{ company?.address ?? "" }}
              </span>
            </div>
          </div>
        </section>

        <div class="flex flex-col gap-2 mt-10 max-w-sm m-auto" *ngIf="!stud?.eligible">
          <h3 class="text-black/30 text-center mb-2">
            <span class="text-3xl">{{stud?.percentageString}}</span>
            <small class="text-[1rem] ml-1">Paid</small>
          </h3>
          <p class="text-red-600 mb-2 max-w-sm mx-auto text-center">{{ stud?.eligibilityMessage}}</p>
        </div>


        <div class="" *ngIf="stud?.eligible">

          <div class="relative flex items-center justify-center -mt-2 mb-0.5">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative bg-white px-4 text-center text-gray-500">
              <div class="flex space-x-1 uppercase px-4 py-2 shadow-md border text-2xl font-bold tracking-tight">
                <span>{{ stud?.session_year }} - Weighted Report</span>
              </div>
            </div>
          </div>
          <section class="flex items-center space-x-2">
            <div class="w-[40%] flex items-center space-x-4">
              <div class="w-24 h-24 overflow-hidden">
                <img src="{{ stud?.passport }}"
                  class="w-[80px] h-[80px] object-cover border border-gray-300 shadow-sm rounded-lg"
                  onerror="this.src='assets/images/man.png'" alt="Student Image" />
              </div>
              <div class="flex flex-col justify-between uppercase w-full truncate">
                <div class="font-semibold text-2xl w-full truncate">
                  {{ stud?.student_name }}
                </div>
                <div class="text-xl font-semibold w-full truncate">
                  {{ stud?.matric_no }}
                </div>
                <div class="flex space-x-2 text-sm w-full text-gray-600 uppercase">
                  <span>{{ stud?.gender }}</span>
                  <span *ngIf="stud?.gender && stud?.date_of_birth && dob">/</span>
                  <span *ngIf="dob && stud?.date_of_birth">DOB: {{ stud?.date_of_birth | date : "dd/MM/yyyy" }}</span>
                </div>
              </div>
            </div>

            <div class="w-[40%]">
              <div class="text-2xl font-bold uppercase truncate flex">
                <div class="cc">{{ stud?.category }}</div>
                <div class="mx-0.5">-</div>
                <div class="cc">{{ stud?.name }}</div>
                <div class="mx-0.5">-</div>
                <div class="cc">{{ stud?.tag }}</div>
              </div>
              <div class="flex space-x-2 text-base items-center uppercase truncate">
                <span class="font-semibold text-xs">Class Teacher:</span>
                <span class="text-xl font-bold truncate">{{ stud?.staff_name }}</span>
              </div>
            </div>

            <ng-container *ngIf="class_position && stud?.new_version">
              <div class="w-[20%] flex flex-col">
                <ng-container>
                  <div class="flex items-center space-x-2 text-gray-900">
                    <div class="text-base font-semibold w-[7rem]">Student Pos:</div>
                    <div class="text-2xl font-bold">
                      <ng-container *ngIf="fetch_for_all">
                        {{ stud?.cd?.w_f_position | number : "2.0" }}
                      </ng-container>
                      <ng-container *ngIf="!fetch_for_all">
                        {{ stud?.cd?.w_position | number : "2.0" }}
                      </ng-container>

                    </div>
                  </div>

                  <div class="flex items-center space-x-2 bg-orange-50 text-sm">
                    <div class="font-semibold w-[7rem]">No. Students:</div>
                    <div class="font-bold">
                      <ng-container *ngIf="fetch_for_all">
                        {{ stud?.cd?.f_count  }}
                      </ng-container>
                      <ng-container *ngIf="!fetch_for_all">
                        {{ stud?.cd?.count }}
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

              </div>
            </ng-container>
          </section>
          <div class="relative flex items-center justify-center my-0.5 mb-2">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
          </div>

          <div class="flex p-2 font-bold uppercase items-center text-sm">

            <div class="w-[50%] text-left">
              Next Term Begins:
              {{
      stud?.cd?.curr_term?.next_term_begins
        ? (stud?.cd.curr_term.next_term_begins | date : "mediumDate")
        : "-"
    }}
            </div>
          </div>

          <section>
            <ng-container *ngIf="show_total">
              <table class="table-auto w-full border-collapse border border-gray-500">
                <thead>
                  <tr>
                    <th class="tt w-[4%]">#</th>
                    <th class="tt w-1/4">Subject</th>
                    <th colspan="2" class="tt w-1/12 bg-indigo-50" *ngIf="
                ((stud?.cd?.t1 || !stud?.cd?.t1) && !missing_term) ||
                (missing_term && stud?.cd?.t1)
              ">
                      1st Term
                    </th>
                    <th colspan="2" class="tt w-1/12 bg-yellow-50" *ngIf="
                ((stud?.cd?.t2 || !stud?.cd?.t2) && !missing_term) ||
                (missing_term && stud?.cd?.t2)
              ">
                      2nd Term
                    </th>
                    <th colspan="2" class="tt w-1/12 bg-purple-50" *ngIf="
                ((stud?.cd?.t3 || !stud?.cd?.t3) && !missing_term) ||
                (missing_term && stud?.cd?.t3)
              ">
                      3rd Term
                    </th>
                    <th class="tt w-1/12">Term Total</th>
                    <th class="tt w-1/12" *ngIf="stud?.cd?.cc_grade == 'Y'">Grade</th>
                    <th class="tt w-1/12">Total</th>
                    <th class="tt w-1/12">T. Avg</th>
                    <ng-container *ngIf="stud?.new_version">
                      <th class="tt w-1/12" *ngIf="subject_position">T. Pos.</th>
                      <ng-container *ngIf="hilo">
                        <th colspan="2" class="tt w-1/12 bg-green-50 text-xs">
                          Highest Sc.
                        </th>
                        <th colspan="2" class="tt w-1/12 bg-red-50 text-xs">
                          Lowest Sc.
                        </th>
                      </ng-container>
                    </ng-container>
                    <th class="tt w-[10%]" *ngIf="stud?.cd?.cc_grade == 'Y'">Remark</th>
                  </tr>
                  <tr class="sub">
                    <th></th>
                    <th>
                      <div class="flex space-x-1 text-xs">
                        <div class="flex-1" *ngIf="
                    ((stud?.cd?.t1 || !stud?.cd?.t1) && !missing_term) ||
                    (missing_term && stud?.cd?.t1)
                  ">
                          [T.1 = {{ stud?.cd?.tts1 ?? 0 }}]
                        </div>
                        <div class="flex-1" *ngIf="
                    ((stud?.cd?.t2 || !stud?.cd?.t2) && !missing_term) ||
                    (missing_term && stud?.cd?.t2)
                  ">
                          [T.2 = {{ stud?.cd?.tts2  ?? 0 }}]
                        </div>
                        <div class="flex-1" *ngIf="
                    ((stud?.cd?.t3 || !stud?.cd?.t3) && !missing_term) ||
                    (missing_term && stud?.cd?.t3)
                  ">
                          [T.3 = {{ stud?.cd?.tts3  ?? 0 }}]
                        </div>
                      </div>
                    </th>
                    <ng-container *ngIf="
                ((stud?.cd?.t1 || !stud?.cd?.t1) && !missing_term) ||
                (missing_term && stud?.cd?.t1)
              ">
                      <th class="bg-indigo-50 wtd">Wtd</th>
                      <th class="bg-indigo-50">Total</th>
                    </ng-container>
                    <ng-container *ngIf="
                ((stud?.cd?.t2 || !stud?.cd?.t2) && !missing_term) ||
                (missing_term && stud?.cd?.t2)
              ">
                      <th class="bg-indigo-50 wtd">Wtd</th>
                      <th class="bg-indigo-50">Total</th>
                    </ng-container>
                    <ng-container *ngIf="
                ((stud?.cd?.t3 || !stud?.cd?.t3) && !missing_term) ||
                (missing_term && stud?.cd?.t3)
              ">
                      <th class="bg-indigo-50 wtd">Wtd</th>
                      <th class="bg-indigo-50">Total</th>
                    </ng-container>

                    <th *ngIf="stud?.cd?.cc_grade == 'Y'"></th>
                    <ng-container *ngIf="stud?.new_version">
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </ng-container>
                    <th class="bg-green-50 wtd">Wtd</th>
                    <th class="bg-green-50">Total</th>
                    <th class="bg-red-50 wtd">Wtd</th>
                    <th class="bg-red-50">Total</th>
                    <th *ngIf="stud?.cd?.cc_grade == 'Y'"></th>
                  </tr>
                </thead>
                <tbody *ngIf="
            student && student.subjects && stud?.subjects.length > 0
          ">
                  <ng-container *ngFor="let sub of student.subjects; let i = index">
                    <tr *ngIf="include_zero || (!include_zero && !sub.is_zero)">
                      <td>
                        {{ i + 1 }}
                      </td>
                      <td class="uppercase">
                        <div class="w-[14em] truncate">
                          {{ sub.title }}
                        </div>
                      </td>
                      <ng-container *ngIf="
                  ((stud?.cd?.t1 || !stud?.cd?.t1) && !missing_term) ||
                  (missing_term && stud?.cd?.t1)
                ">
                        <td class="bg-indigo-50 wtd">
                          {{ sub.t1available ? sub.terms[0]?.weighted : "-" }}
                        </td>
                        <td class="bg-indigo-50">
                          {{ sub.t1available ? sub.terms[0].total : "-" }}
                        </td>
                      </ng-container>
                      <ng-container *ngIf="
                  ((stud?.cd?.t2 || !stud?.cd?.t2) && !missing_term) ||
                  (missing_term && stud?.cd?.t2)
                ">
                        <td class="bg-indigo-50 wtd">
                          {{ sub.t2available ? sub.terms[0]?.weighted : "-" }}
                        </td>
                        <td class="bg-indigo-50">
                          {{ sub.t2available ? sub.terms[0].total : "-" }}
                        </td>
                      </ng-container>
                      <ng-container *ngIf="
                  ((stud?.cd?.t3 || !stud?.cd?.t3) && !missing_term) ||
                  (missing_term && stud?.cd?.t3)
                ">
                        <td class="bg-indigo-50 wtd">
                          {{ sub.t3available ? sub.terms[0]?.weighted : "-" }}
                        </td>
                        <td class="bg-indigo-50">
                          {{ sub.t3available ? sub.terms[0].total : "-" }}
                        </td>
                      </ng-container>

                      <td class="wtd">
                        {{ sub.weighted }}
                      </td>
                      <td *ngIf="stud?.cd?.cc_grade == 'Y'" class="font-bold uppercase">
                        {{ sub?.grade }}
                      </td>
                      <td>
                        {{ sub.total }}
                      </td>
                      <td class="wtd">
                        {{ sub.weighted_average }}
                      </td>
                      <ng-container *ngIf="stud?.new_version">
                        <td *ngIf="subject_position">
                          {{ sub?.sub_position ?? "P" }}
                        </td>
                        <ng-container *ngIf="hilo">
                          <td class="bg-green-50 wtd">{{ sub.highest_weighted }}</td>
                          <td class="bg-green-50">{{ sub.highest_total }}</td>
                          <td class="bg-red-50 wtd">{{ sub.lowest_weighted }}</td>
                          <td class="bg-red-50">{{ sub.lowest_total }}</td>
                        </ng-container>
                      </ng-container>
                      <td *ngIf="stud?.cd?.cc_grade == 'Y'">
                        <div class="w-[8em] truncate uppercase">
                          {{ sub.comment }}
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </ng-container>

            <ng-container *ngIf="!show_total">
              <table class="table-auto w-full border-collapse border border-gray-500">
                <thead>
                  <tr>
                    <th class="tt w-[4%]">#</th>
                    <th class="tt w-1/4">Subject</th>
                    <th class="tt w-1/12 bg-indigo-50" *ngIf="
                ((stud?.cd?.t1 || !stud?.cd?.t1) && !missing_term) ||
                (missing_term && stud?.cd?.t1)
              ">
                      <div class="text-sm">1st Term</div>
                      <div class="text-xs" *ngIf="stud?.new_version">[ {{ stud?.cd?.tts1 ?? 0 }} ]</div>
                    </th>
                    <th class="tt w-1/12 bg-yellow-50" *ngIf="
                ((stud?.cd?.t2 || !stud?.cd?.t2) && !missing_term) ||
                (missing_term && stud?.cd?.t2)
              ">
                      <div class="text-sm">2nd Term</div>
                      <div class="text-xs" *ngIf="stud?.new_version">[ {{ stud?.cd?.tts2  ?? 0 }} ]</div>
                    </th>
                    <th class="tt w-1/12 bg-purple-50" *ngIf="
                ((stud?.cd?.t3 || !stud?.cd?.t3) && !missing_term) ||
                (missing_term && stud?.cd?.t3)
              ">
                      <div class="text-sm">3rd Term</div>
                      <div class="text-xs" *ngIf="stud?.new_version">[ {{ stud?.cd?.tts3  ?? 0 }} ]</div>
                    </th>
                    <th class="tt w-1/12">Total</th>
                    <th class="tt w-1/12" *ngIf="stud?.cd?.cc_grade == 'Y'">Grade</th>
                    <th class="tt w-1/12">T. Avg</th>
                    <ng-container *ngIf="stud?.new_version">
                      <th class="tt w-1/12" *ngIf="subject_position">T. Pos.</th>
                      <ng-container *ngIf="hilo">
                        <th class="tt w-1/12 bg-green-50 text-xs">High T.</th>
                        <th class="tt w-1/12 bg-red-50 text-xs">Low T.</th>
                      </ng-container>
                    </ng-container>
                    <th class="tt w-[10%]" *ngIf="stud?.cd?.cc_grade == 'Y'">Remark</th>
                  </tr>
                </thead>
                <tbody *ngIf="
            student && student.subjects && stud?.subjects.length > 0
          ">
                  <ng-container *ngFor="let sub of student.subjects; let i = index">
                    <tr>
                      <td>
                        {{ i + 1 }}
                      </td>
                      <td class="uppercase">
                        <div class="w-[14em] truncate">
                          {{ sub.title }}
                        </div>
                      </td>
                      <td class="bg-indigo-50 wtd">
                        {{ sub.tw1 ?? "-" }}
                      </td>
                      <td class="bg-yellow-50 wtd">
                        {{ sub.tw2 ?? "-" }}
                      </td>
                      <td class="bg-purple-50 wtd">
                        {{ sub.tw3 ?? "-" }}
                      </td>
                      <td class="wtd">
                        {{ sub.total}}
                      </td>
                      <td *ngIf="stud?.cd?.cc_grade == 'Y'" class="font-bold uppercase">
                        {{ sub.grade }}
                      </td>
                      <td class="wtd">
                        {{ sub.weighted_avg }}
                      </td>
                      <ng-container *ngIf="stud?.new_version">
                        <td *ngIf="subject_position">
                          {{ fetch_for_all ? sub.w_f_sub_position : sub.w_sub_position  }}
                        </td>
                        <ng-container *ngIf="hilo">
                          <td class="bg-green-50">
                            {{ fetch_for_all ? sub.f_w_highest_score : sub.w_highest_score }}
                          </td>
                          <td class="bg-red-50">
                            {{ fetch_for_all ? sub.f_w_lowest_score : sub.w_lowest_score }}
                          </td>
                        </ng-container>
                      </ng-container>
                      <td *ngIf="stud?.cd?.cc_grade == 'Y'">
                        <div class="w-[8em] truncate uppercase">
                          {{ sub.comment }}
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </ng-container>

            <div *ngIf="stud?.subjects.length == 0" class="uppercase font-bold text-xl p-2">
              No results is found for session
            </div>
          </section>


          <section class="flex mt-4 space-x-4 skb">
            <div class="w-[45%]">
              <div class="w-full">
                <fieldset class="shadow-sm rounded-md p-2 relative">
                  <legend
                    class="text-base font-semibold text-gray-700 px-2 absolute border shadow-sm -top-3 bg-white w-[8em]">
                    Skills
                  </legend>
                  <div class="mt-3 text-gray-700 w-full">
                    <table class="w-full">
                      <tbody>
                        <tr>
                          <td>Hand Writing</td>
                          <td>{{ stud?.skb?.handwriting ?? "-" }}</td>
                        </tr>
                        <tr>
                          <td>Fluency</td>
                          <td>
                            {{ stud?.skb?.fluency ?? "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Sport</td>
                          <td>
                            {{ stud?.skb?.sport ?? "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Handling of tools in lab &amp; workshop</td>
                          <td>
                            {{ stud?.skb?.h_of_tools ?? "-" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="w-[55%]">
              <div class="w-full">
                <fieldset class="shadow-sm rounded-md p-2 relative">
                  <legend
                    class="text-base font-semibold text-gray-700 px-2 absolute border shadow-sm -top-3 bg-white w-[8em]">
                    Behaviour
                  </legend>
                  <div class="mt-3 text-gray-700 w-full">
                    <table class="w-full">
                      <tbody>
                        <tr>
                          <td>Punctuality</td>
                          <td>{{ stud?.skb?.punctuality ?? "-" }}</td>
                        </tr>
                        <tr>
                          <td>Neatness</td>
                          <td>
                            {{ stud?.skb?.neatness ?? "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Politeness</td>
                          <td>
                            {{ stud?.skb?.politeness ?? "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Relationship with other student</td>
                          <td>
                            {{ stud?.skb?.rel_with_student ?? "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Organization Ability</td>
                          <td>
                            {{ stud?.skb?.organisation_ab ?? "-" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </div>
            </div>
          </section>

          <section>
            <div class="w-full">
              <fieldset class="shadow-sm rounded-md p-2 relative">
                <legend
                  class="text-base font-semibold text-gray-700 px-2 absolute border shadow-sm -top-3 bg-white w-[8em]">
                  Comments
                </legend>
                <div class="flex flex-col gap-2 mt-3">
                  <!-- Teacher Comment -->
                  <div class="flex items-center">
                    <label class="w-[100px] font-semibold text-gray-600 pt-2 text-sm">Class Teacher:</label>
                    <div class="flex-1 border p-2 font-bold rounded-md bg-gray-100 uppercase">
                      {{ stud?.ct_comment ?? "-" }}
                    </div>
                  </div>
                  <!-- Principal Comment -->
                  <div class="flex items-center">
                    <label
                      class="w-[100px] font-semibold text-gray-600 pt-2 text-sm truncate">{{ stud?.leader }}:</label>
                    <div class="flex-1 border p-2 font-bold rounded-md bg-gray-100 uppercase">
                      {{ stud?.p_comment ?? "-" }}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </section>

          <section class="grid grid-cols-2 gap-6 mt-5" *ngIf="stud?.ct_signature && stud?.p_signature">
            <div class="flex flex-col items-center text-center">
              <img [src]="stud?.ct_signature" class="w-32 h-16 object-cover rounded-lg" alt="Class Teacher Signature" />
              <div class="mt-1 text-lg font-semibold text-gray-700">
                Class Teacher
              </div>
            </div>
            <div class="flex flex-col items-center text-center">
              <img [src]="stud?.p_signature" class="w-32 h-16 object-cover rounded-lg" alt="Leader Signature" />
              <div class="mt-1 text-lg font-semibold text-gray-700">
                {{ stud?.leader }}
              </div>
            </div>
          </section>

        </div>
      </div>
      <footer class="fixed inset-x-0 bottom-0 w-full px-4">
        <div class="bg-gray-800 text-white flex justify-between items-center px-4 py-1">
          <div class="text-lg font-bold">Edozzier</div>
          <div class="text-sm">Edu-verse For Forward Thinking Institutions</div>
        </div>
      </footer>

    </div>
  </div>